import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import { connectTo } from '../../utils';
import { useAppWidthClass } from '../../utils/hooks';
import toErrorKey from './utils';

import { NAVBAR_HOME_KEY } from '../../reducers/ui';
import { PAY_NOW_TEXT_KEY } from '../../constants/payment';
import { HOME, PAYMENTS } from '../../constants/routes';
import * as errorTypes from '../../constants/errorStatuses';

import {
  Link,
  Module,
  ThemeButton,
  Translation
} from '../../components/common';

import leela from '../../assets/img/error/troy-Leela-Error 1.png';

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: '16px',
    display: 'flex'
  },
  wrapperDesktop: {
    padding: '40px 124px 45px 124px',
    flexDirection: 'row',
    alignItems: 'center'
  },
  wrapperTablet: {
    padding: '40px 35.5px',
    flexDirection: 'row'
  },
  wrapperMobile: {
    padding: '16px 24px 40px 24px',
    flexDirection: 'column',
    alignItems: 'center'
  },
  leelaDesktop: {
    width: 214,
    height: 271
  },
  leelaTablet: {
    width: 141,
    height: 179
  },
  leelaMobile: {
    width: 120,
    height: 153
  },
  contentDesktop: {
    marginLeft: 56
  },
  contentTablet: {
    marginLeft: 32
  },
  contentMobile: {
    textAlign: 'center'
  },
  description: {
    marginTop: 24
  },
  button: {
    marginTop: 24,
    minWidth: 184
  }
}));

const ErrorPage = ({ status }) => {
  const classes = useStyles();
  const { isMobileWidth, isTabletWidth, isDesktopWidth } = useAppWidthClass();
  const key = toErrorKey(status);

  const hasPaymentLink = [
    errorTypes.PAYMENT_CANCEL,
    errorTypes.PAYMENT_EXPIRED,
    errorTypes.PAYMENT_FAIL,
    errorTypes.PAYMENT_PENDING,
    errorTypes.PAYMENT_UNAUTHORIZED
  ].includes(status);

  return (
    <Module
      className={classNames(
        classes.wrapper,
        isDesktopWidth && classes.wrapperDesktop,
        isTabletWidth && classes.wrapperTablet,
        isMobileWidth && classes.wrapperMobile
      )}
    >
      <img
        src={leela}
        alt="leela"
        className={classNames(
          isDesktopWidth && classes.leelaDesktop,
          isTabletWidth && classes.leelaTablet,
          isMobileWidth && classes.leelaMobile
        )}
      />
      <Box
        className={classNames(
          isDesktopWidth && classes.contentDesktop,
          isTabletWidth && classes.contentTablet,
          isMobileWidth && classes.contentMobile
        )}
      >
        <Typography component="h1" variant="h2" color="secondary">
          <Translation inline>ERROR_PAGE_HEADER</Translation>
        </Typography>
        <Typography
          variant="body1"
          color="textPrimary"
          className={classes.description}
        >
          <Translation inline>{key}</Translation>
        </Typography>
        <ThemeButton
          className={classes.button}
          id={
            hasPaymentLink
              ? 'page.error.component.pay-now.pay-now-link'
              : 'page.error.component.error.home-link'
          }
          variant="contained"
          component={React.forwardRef((props, ref) => (
            <Link to={hasPaymentLink ? PAYMENTS : HOME} {...props} ref={ref} />
          ))}
          textKey={hasPaymentLink ? PAY_NOW_TEXT_KEY : NAVBAR_HOME_KEY}
        />
      </Box>
    </Module>
  );
};

export default connectTo(
  ({ error: { status } }) => ({ status }),
  {},
  ErrorPage
);
